export enum PerfMark {
  LoadStart = 'load-start',
  LoadEnd = 'load-end',
  OpenStart = 'open-start',
  OpenEnd = 'open-end',
}
